/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-03-02 14:41:55
 * @LastEditors: snzo.chen
 * @LastEditTime: 2021-10-28 22:32:28
 */
import {
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { StorageService } from './services/storage.service';
import { ImagesService } from './services/images.service';
import MenuConfig from 'src/assets/utils/menuConfig';
import { API_CONFIG_UNION } from './services/services.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {
  userHeader: string;
  menuConfig: any = [];
  friendOfData: any[] = [];
  @ViewChild('partnerList', { static: true }) partnerList!: ElementRef;
  @ViewChild('partnerItem01', { static: true }) partnerItem01!: ElementRef;
  mr: any;
  ml = 0;
  unionUrl!: string;
  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private r2: Renderer2,
    private elRef: ElementRef,
    private imageService: ImagesService,
    @Inject(API_CONFIG_UNION) private $unionUrl: string
  ) {
    this.unionUrl = this.$unionUrl;
    this.menuConfig = MenuConfig.filter((item) => item.isShow);
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        const isLoggedIn = this.storageService.getStorage('isLoggedIn');
        this.authService.operator = isLoggedIn;
        this.userHeader = isLoggedIn;
      }
    });
  }
  ngOnInit(): void {
    this.getFriendList();
  }

  exit(): void {
    this.authService.logout();
    this.userHeader = null;
  }

  /**友情链接模块 */
  getFriendList() {
    this.imageService
      .getImagesList(
        { pageNum: 1, pageSize: 999 },
        { belongSortid: 3, isOpen: 1 }
      )
      .subscribe((res) => {
        if (res.status === 200) {
          this.friendOfData = res.data.seachList;
          const friendRef =
            this.elRef.nativeElement.querySelector('.friend-items');
          this.r2.setStyle(friendRef, 'width', 190 * 6);
          this.startMqrquee();
        }
      });
  }

  /**
   * @description: 友链无缝滚动
   */
  marqueePartner() {
    if (this.partnerList) {
      const pEl = this.partnerList.nativeElement;
      const pItem01 = this.partnerItem01.nativeElement;
      if (pItem01.offsetWidth - this.ml <= 0) {
        this.ml -= pItem01.offsetWidth;
      } else {
        this.ml++;
        this.r2.setStyle(pEl, 'margin-left', -this.ml + 'px');
      }
    }
  }
  /**
   * @description: 开始滚动
   */
  startMqrquee() {
    this.mr = setInterval(() => {
      this.marqueePartner();
    }, 20);
  }
  /**
   * @description: 停止滚动
   */
  stopMarquee() {
    clearInterval(this.mr);
  }
}
